/* eslint-disable max-len */
import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';

export const ALERT_BEFORE_SECRETS_REGENERATION_OTP_SEND_MSG =
  'To ensure that changes have not been made by an unauthorized person, we will ask you for verification. In the next step you will receive One-time password (OTP) to your mailbox and sms. Please make sure you have access to them.';

export const ALERT_BEFORE_OTP_SEND_MSG =
  'In next step you will receive a one-time password (OTP) to your mailbox and/or sms. Make sure you have access to them.';

export const ALERT_BEFORE_OTP_SEND_MSG_IN_EDIT =
  'To ensure that changes have not been made by an unauthorized person, we will ask you for verification. In the next step you will receive a one-time password (OTP) to your phone. Please make sure you have access to them.';

export const AlertBeforeOtpSend = () => <AlertBoxMsg severity="info">{ALERT_BEFORE_OTP_SEND_MSG}</AlertBoxMsg>;
export const ALERT_BEFORE_OTP_SEND_MSG_CREATE_FORM =
  'In the next step we will ask you verify your phone number with One-time password (OTP). Please make sure you have access to your phone.';
export const AlertBeforeOtpSendInCreateForrm = () => (
  <AlertBoxMsg severity="info">
    <Box>
      <Box sx={{ marginBottom: '8px' }}>Information about the OTP verification</Box>
      {ALERT_BEFORE_OTP_SEND_MSG_CREATE_FORM}
    </Box>
  </AlertBoxMsg>
);

export const AlertBeforeOtpSendInEdit = () => (
  <AlertBoxMsg severity="info">
    <Box>
      <Box sx={{ marginBottom: '8px', color: '#2196F3 !important' }}>Information about the OTP verification</Box>
      <Box>{ALERT_BEFORE_OTP_SEND_MSG_IN_EDIT}</Box>
    </Box>
  </AlertBoxMsg>
);

export const AlertWhenOtpSendedToMailbox = ({ timeInMinutes = 60 }: { timeInMinutes?: number }) => (
  <AlertBoxMsg severity="info">
    {`One-time password (OTP) have been sent to your mailbox. If you do not provide them within ${timeInMinutes} minutes, you will need to repeat the process.`}
  </AlertBoxMsg>
);

export const AlertWhenOtpSendedToMailboxAndSms = ({ timeInMinutes = 60 }: { timeInMinutes?: number }) => (
  <AlertBoxMsg severity="info">
    {`One-time password (OTP) have been sent to your SMS. If you do not provide them within ${timeInMinutes} minutes, you will need to repeat the process.`}
  </AlertBoxMsg>
);

export const AlertWhenOtpSendedToSms = ({ timeInMinutes = 60 }: { timeInMinutes?: number }) => (
  <AlertBoxMsg severity="info">
    {`One-time password (OTP) have been sent to your SMS. If you do not provide them within ${timeInMinutes} minutes, you will need to repeat the process.`}
  </AlertBoxMsg>
);

export const InfoWhenActionEndWithSuccess = () => (
  <AlertBoxMsg severity="success">Account information successfully updated</AlertBoxMsg>
);
